(function(){
    'use strict';
    angular.module('app').controller('ProviderLocationDetailsModalController', ProviderLocationDetailsModalController);
    ProviderLocationDetailsModalController.$inject = [
        'PopLockerOperatingHoursTable',
        '$timeout',
        '$uibModalInstance',
        'PopLockerService',
        'toastr',
        'data'
    ];
    function ProviderLocationDetailsModalController(
        PopLockerOperatingHoursTable,
        $timeout,
        $uibModalInstance,
        PopLockerService,
        toastr,
        data
    ) {
        const vm = this;
        vm.details = {};

        vm.cancel = cancel;
        vm.save = save;

        init();

        function init() {
            if (data) {
                vm.details = data;
            }

            initTable();
        }

        function initTable() {
            $timeout(function () {
                vm.operationsTable = new PopLockerOperatingHoursTable({
                    locationForm: vm.operatingHoursFrm,
                    operatingHours: data ? data.operatingHoursData : null,
                });
            }, 1000);
        }

        function cancel() {
            $uibModalInstance.dismiss();
        }

        function save(...forms) {
            const validForms = forms.every(form => {
                form.$setSubmitted(true);
                return !!form.$valid;
            });

            if (!validForms) { return; }


            if (vm.details.id) {
                updateLocation();
                return;
            }

            addNewLocation();
        }

        function updateLocation() {
            const id = vm.details.id;
            vm.details.operatingHours = vm.operationsTable.tableData.data;
            const payload = PopLockerService.locationPayloadMapper(vm.details);

            vm.isSaving = true;
            PopLockerService.updateLocation(success => {
                toastr.success('Location updated successfully');
                vm.isSaving = false;
                $uibModalInstance.close(success);
            }, error => {
                vm.isSaving = false;
                toastr.error('Error', error.message);
            }, payload);
        }

        function addNewLocation() {
            vm.details.operatingHours = vm.operationsTable.tableData.data;
            const payload = PopLockerService.locationPayloadMapper(vm.details);

            vm.isSaving = true;
            PopLockerService.addLocation(success => {
                toastr.success('Location Added');
                vm.isSaving = false;
                $uibModalInstance.close(success);
            }, error => {
                vm.isSaving = false;
                toastr.error('Error', error.message);
            }, payload);
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/modal/ProviderLocationDetailsModalController.js